const CurrencyFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  // minimumFractionDigits: 0,
  // maximumFractionDigits: 0,
});
export default CurrencyFormatter;
